<h2 class="page-heading">Message</h2>

<mat-tab-group (selectedTabChange)="onTabChange($event)">

    <mat-tab label="Holiday List">
        <app-holiday></app-holiday>
    </mat-tab>

    <mat-tab label="Message List">

        <app-response-text 
        [lambdaMessage]="lambdaMessage" 
        [lambdaError]="lambdaError">
        </app-response-text>

        <div class="table-container">

            <div class="filter-select ">
                <select class="custom-select table-select" [(ngModel)]="typeSelect"
                    (change)="applyFilter(); lambdaMessage = ''; lambdaError = false">
                    <option class="custom-option" ngValue="NoFilter" selected>No Filter</option>
                    <option class="custom-option" *ngFor="let type of messageTypes" [ngValue]="type">{{type}}</option>
                </select>
            </div>

            <!--messages table-->
            <div *ngIf="filterSelected">
                <app-data-grid 
                    [data]="filteredData" 
                    (itemChange)="updateItem($event);"     
                    (buttonEvent)="lambdaMessage = ''; lambdaError = false;" 
                    [(isValid)]="formValid"
                    [viewTemplate]="view" 
                    [formTemplate]="formView"
                    [columnNames]="['Type', 'Title', 'Message', 'Start Date', 'Start Time', 'End Date', 'End Time', 'Last Updated', 'Updated By', 'Status']"
                    [spacing]="[8, 8, 25, 8, 6, 8, 6, 10, 12, 10, 8]" 
                    [itemsPerPage]="5" [objectBluePrint]="bluePrint"
                    [overwriteEditedItem]="editOverWrite" 
                    [allowDelete]="false">

                    <!--view-->
                    <ng-template #view let-item>
                        <td>{{item.message.messageType}}</td>
                        <td>
                            <div class="lefty">{{item.message.messageTitle}}</div>
                        </td>
                        <td>
                            <ul>
                                <li *ngFor="let message of item.message.msgText | keyvalue">
                                    <span><strong>{{getLangByCode(message.key)}}: </strong>{{message.value}}</span>
                                </li>
                            </ul>
                        </td>
                        <td>{{timeService.unitedStatesFormat(item.messageDuration.messageStartDate)}}</td>
                        <td>{{item.messageDuration.messageStartTime}}</td>
                        <td>{{timeService.unitedStatesFormat(item.messageDuration.messageEndDate)}}</td>
                        <td>{{item.messageDuration.messageEndTime}}</td>
                        <td>{{item.lastUpdated}}</td>
                        <td>{{item.updatedBy}}</td>
                        <td>{{item.message.status}}</td>
                    </ng-template>

                    <!--form-->
                    <ng-template #formView let-item>
                        <!--Type-->
                        <td>
                            <select class="custom-select spaced" [(ngModel)]="item.message.messageType"
                                (ngModelChange)="validate(item); handleHolidaySelect(item.message.messageType)">
                                <option class="custom-option" selected hidden value="">Message Type</option>
                                <option class="custom-option" *ngFor="let type of messageTypes" [ngValue]="type">
                                    {{type}}</option>
                            </select>

                            <select class="custom-select spaced" *ngIf="item.message.messageType == 'Holidays'"
                                [(ngModel)]="holidaySelect"
                                (ngModelChange)="updateGridWithHolidayData(item, holidaySelect); this.holidaySelect='DEFAULT';"
                                (focusout)="validate(item);">
                                <option class="custom-option" selected hidden value="DEFAULT">Select Holiday</option>
                                <option class="custom-option" *ngFor="let holiday of holidayData" [ngValue]="holiday">
                                    {{holiday.holiday}}</option>
                            </select>
                        </td>

                        <!--Title-->
                        <td><input type="text" [(ngModel)]="item.message.messageTitle" placeholder="..."
                                (ngModelChange)="validate(item)"></td>

                        <!--Message-->
                        <td>
                            <ul>
                                <li *ngFor="let key of getMessageKeys(item)" class="message-container">
                                    <div class="message-edit">
                                        <span>{{getLangByCode(key)}} <button class="message-btn"
                                                (click)="deleteMessage(item, key); validate(item);">
                                                <div uk-icon="icon: trash; ratio: .75;"></div>
                                            </button> </span>
                                        <textarea [(ngModel)]="item.message.msgText[key]"
                                            (ngModelChange)="validate(item)"
                                            placeholder="Enter Message here..."></textarea>
                                    </div>
                                </li>
                                <br>
                                <select class="custom-select" [(ngModel)]="selectedLang">
                                    <option class="custom-option" hidden selected value="DEFAULT">Select Language
                                    </option>
                                    <option class="custom-option" *ngFor="let lang of getAvailableLangs(item)"
                                        [value]="lang[1]">{{lang[0]}}</option>
                                </select>
                                <button (click)="addMessage(item); validate(item);"
                                    [disabled]="selectedLang == 'DEFAULT'"> + </button>
                            </ul>
                        </td>

                        <!--startDate-->
                        <td><input type="date" [(ngModel)]="item.messageDuration.messageStartDate"
                                (ngModelChange)="item.messageDuration.messageEndDate = item.messageDuration.messageStartDate; validate(item);">
                        </td>

                        <!--Start Time-->
                        <td><input type="time" [(ngModel)]="item.messageDuration.messageStartTime"
                                (ngModelChange)="validate(item)"></td>

                        <!--End date-->
                        <td><input type="date" [(ngModel)]="item.messageDuration.messageEndDate"
                                (ngModelChange)="validate(item)"></td>

                        <!--end time-->
                        <td><input type="time" [(ngModel)]="item.messageDuration.messageEndTime"
                                (ngModelChange)="validate(item)"></td>

                        <td>{{item.message.lastUpdated}}</td>
                        <td>{{item.message.updatedBy}}</td>

                        <!--Status-->
                        <td>
                            <select class="custom-select" [(ngModel)]="item.message.status"
                                (ngModelChange)="validate(item)">
                                <option class="custom-option" value="Enabled">Enabled</option>
                                <option class="custom-option" value="Disabled">Disabled</option>
                            </select>
                        </td>
                    </ng-template>

                </app-data-grid>
                <br>

            </div>

        </div>
        <br>
    </mat-tab>

</mat-tab-group>